import { requiredFields } from 'app/area/administration/edit/role/role-edit-configuration';
import { DefaultRole, PersonActionType } from 'app/area/administration/shared/types';
import { Person } from 'app/components/access-panel/shared/types';
import { FormValuesType } from 'app/infrastructure/simple-form/types';

export interface ShouldDefaultRolePrompt {
  actionType: PersonActionType;
  formValues: FormValuesType;
  markedAsDefaultRole: boolean;
  currentDefaultRole: DefaultRole;
  data: Person;
}

export const shouldDefaultRolePrompt = (
  { actionType, formValues, markedAsDefaultRole, currentDefaultRole, data }: ShouldDefaultRolePrompt
): boolean => {

  if (!currentDefaultRole?.value) {
    return false;
  }

  const validForm = requiredFields
    .map(field => formValues?.[field])
    .filter(f => f)
    ?.length === requiredFields.length;

  const hasCurrentDefaultRole = currentDefaultRole?.value === data?.id;
  const duplicateCondition = actionType === PersonActionType.duplicate && hasCurrentDefaultRole;
  const defaultRole = markedAsDefaultRole && (duplicateCondition || !hasCurrentDefaultRole);

  return validForm && defaultRole;
};
